import { ENUM__redux_action } from '@/state/_base/ENUM__redux_action';
import { PayloadAction } from '@reduxjs/toolkit';
import { assert_false, assert_hash_sha256_not_empty } from '@shared/asserts/utils_asserts';
import { DTO__image_asset } from '@shared/dto/+image/image_asset_base/DTO__image_asset';
import { STATE__images } from '../STATE__images';

export const LOCAL__images_upsert = (items: DTO__image_asset[]): PayloadAction<DTO__image_asset[]> => ({
  type: ENUM__redux_action.IMAGES_UPSERT,
  payload: items,
});

export function INIT_LOCAL__images_upsert(state: STATE__images, action: PayloadAction<DTO__image_asset[]>) {
  let items = action.payload;

  if (items.is_empty()) return;

  let { images_map, images_hashes_loading, meta_map_by_hash_sha256_content } = state;

  for (let item of items) {
    let { hash_sha256_content } = item;

    assert_false(item.is_stub());

    assert_hash_sha256_not_empty(hash_sha256_content);

    let images_meta_map = meta_map_by_hash_sha256_content.get_or_create_array(hash_sha256_content);

    for (let meta of images_meta_map.values()) meta.set_image(item.clone());

    images_hashes_loading.delete(hash_sha256_content);
    images_map.set(item.hash_sha256_content, item);
  }

  //refresh map to trigger re-render
  state.images_map = new Map(images_map);

  //refresh map to trigger re-render
  state.images_hashes_loading = new Set(images_hashes_loading);

  //refresh map to trigger re-render
  state.meta_map_by_hash_sha256_content = new Map(meta_map_by_hash_sha256_content);
}
